interface ApiErrorBody {
  response?: { data?: { message?: unknown } };
  data?: { message?: unknown };
}

const messageOf = (value: unknown): string | undefined => {
  return typeof value === 'string' ? value : undefined;
};

export const apiErrorMessage = (error: unknown): string | undefined => {
  if (typeof error !== 'object' || error === null) return undefined;
  const body = error as ApiErrorBody;
  const responseMessage = messageOf(body.response?.data?.message);
  if (responseMessage !== undefined) return responseMessage;
  return messageOf(body.data?.message);
};
